// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "lottie-web" + "." + "fb2fe328da5274c0" + ".js";
};